import script from "./ArticleEditorOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleEditorOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleEditorOrganism.css?vue&type=style&index=0&id=260b8ecc&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260b8ecc"]])

export default __exports__